import { render, staticRenderFns } from "./node-cbox.vue?vue&type=template&id=285215aa&"
import script from "./node-cbox.vue?vue&type=script&lang=js&"
export * from "./node-cbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports